<template>
  <div class="wrap">
    <div class="banner">
      <i-banner :list=imgList :height="392"></i-banner>
    </div>
    <div class="container">

      <div class="filter-wrap">

        <div class="filterItem">
          <span class="title">分类选择：</span>
          <div class="filterRight">
          <span v-for="(item,index) in typeList"
                :key="item.value"
                @click="egListTab(item,index)"
                class="itemText"
                :class="item.isSelect?'itemActive':''"
          >
            {{ item.text }}
          </span>
          </div>
        </div>

      </div>

      <div class="item_list">
        <div class="liveswill"
             v-for="(item,index) in columnList"
             :key="'liveswill'+index">
          <div class="con"
               @click="toDetails(item.colId)">
            <p class="item_title">
              <span class="title_name">{{ item.egName }}频道</span>
              <span class="title_time">{{ getTimes(item.colCreateDt) }}</span>
            </p>
            <div class="con_img_wrap">
              <div style="position: relative;">
                <div v-if="checkUserMember">
                  <get-vip-img v-if="item.cIsvipfree==1"></get-vip-img>
                </div>

                <img class="con_images"
                    :src="item.colThumbnailUrl"
                    alt=""
                    v-if="item.colThumbnailUrl">
                <img class="con_images"
                    src="../../assets/images/default.png"
                    alt=""
                    v-else>
              </div>
            </div>
            <div class="con_right">
              <p class="con_title">{{ item.colTitle }}</p>
              <div>
                <p class="con_author"><span v-if="item.entity!=null">{{ item.entity.eName }}</span></p>
                <div class="con_bt">
                  <span>参会人数：{{ item.orderNum }}</span>
                  <span class="con_bt_r" v-if="!item.buyed">
                    <span>¥{{ item.currentPrice }}</span>
                   </span>
                  <span class="con_bt_r"
                        style="font-size: 0.26rem"
                        v-if="item.buyed">
                      已购
                    </span>
                  <!-- <span class="con_bt_r"
                        style="font-size: 0.26rem"
                        v-if="item.colIsCharge*1==0">
                      免费
                  </span> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
import iBanner from '../container/banner'
import weui from 'weui.js'
import GetVipImg from '../getvipimg/getVipImg.vue';
import loginService from '../../plugin/extendFn/loginService';
import AppSetting from '../../AppSetting';
export default {
  data() {
    return {
      checkUserMember:true,
      imgList: [],
      originalColList: [],
      columnList: [],
      uid: '',
      ra_wxUser: null,
      typeList: [{value: 1, text: '专家会议', isSelect: false}, {value: 2, text: '课程会议', isSelect: false}]
    }
  },
  props: {},
  created() {
    this.$waiting.show(3);
  },
  methods: {
    getUser(){
      let type = this.ra_wxUser && this.ra_wxUser.uMemberType;
      if(type == 1 || type ==2){
        //this.checkUserMember = true;
      }
      // console.log("----------------------------"+this.ra_wxUser.uMemberType+"   "+this.ra_wxUser.uName); 
    },
    egListTab(res, index) {
      let item = res;
      item.isSelect = !item.isSelect
      this.$set(this.typeList, index, item);

      let arr = [];
      if (this.typeList[0].isSelect) {
        arr.push(1);
      }
      if (this.typeList[1].isSelect) {
        arr.push(2);
      }

      let list = arr.length == 0 ? this.originalColList : this.originalColList.filter((data, index) => arr.includes(data.colType))
      this.columnList = list;
    },

    getData() {
      let param = {
        ccId: "",
        level: "",//轮播图列表 区分轮播图返回的是pc 还是移动的  1 移动 2 pc
        img_type: 2,//轮播图列表 区分轮播图返回的是pc 还是移动的  1 移动 2 pc
        uid: this.ra_wxUser ? (this.ra_wxUser.uId ? this.ra_wxUser.uId : '') : '',
      }
      this.$postHttp(AppSetting.baseUrl + '/live/student/list', param).then((res) => {
        if (res.data.code == 0) {
          this.$waiting.hide();
          let data = res.data.value;
          this.imgList = data.pictures;
        }
      });
      this.$postHttp(AppSetting.baseUrl + '/column/list', {}).then((res) => {
        if (res.data.code == 0) {
          let list = res.data.list;
          let uGenre = this.ra_wxUser ? (this.ra_wxUser.uGenre ? this.ra_wxUser.uGenre : 1) : 1;
          list = list.map(item => {
            let auth = item.auths.find(el => {
              return el.memId == parseInt(uGenre);
            });
            // item.currentPrice = auth && auth.currentPrice;
            item.currentPrice = item.colFees;
            return item;
          });
          console.log(list);
          this.columnList = list;
          this.originalColList = list;
        }
      });

    },
    getTimes(value) {
      return new Date(value).Format("yyyy.MM.dd hh:mm");
    },
    toDetails(id) {
      this.$router.push({
        name: "colDetails",
        query: {type: "column", colId: id}
      });
    },


    async signUp(status, index, lid) {
      if (await loginService.isNotLogin()) {
        this.login()
      } else if ((this.ra_wxUser.uMail == null || this.ra_wxUser.uMail == '' || this.ra_wxUser.uMail == 'null' || this.ra_wxUser.uMail == undefined)
      ) {
        this.$router.push({
          name: 'Login',
        })
      } else if (this.ra_wxUser.uPhone || this.ra_wxUser.uMail) {
        if (status == 0) {
          this.$postHttp('/live/appointment', {
            uid: this.ra_wxUser ? (this.ra_wxUser.uId ? this.ra_wxUser.uId : '') : '',
            lid: lid
          }).then((res) => {
            if (res.data.code == 0) {
              // this.text = '已预约';
              // this.sing = 1;
              // this.list.lives_will[index].lIsAppoint.$set()
              this.$set(this.list.lives_will[index], 'lIsAppoint', 1);
              this.$set(this.list.lives_will[index], 'lAppointNum', res.data.num);
              //参数：要改的对象、要改的key 、要改的值
              this.$message.success('预约成功')
            } else {
              this.$message.error('预约失败')
            }

          })
        } else {
          weui.dialog({
            content: '确定要取消预约吗？',
            className: 'yors',
            buttons: [{
              label: '取消',
              type: 'default',
              onClick: (res) => {
                // alert('取消')
              }
            }, {
              label: '确定',
              type: 'primary',
              onClick: () => {

                this.$postHttp('/live/appointment/cancel', {
                  uid: this.ra_wxUser ? (this.ra_wxUser.uId ? this.ra_wxUser.uId : '') : '',
                  lid: lid
                }).then((res) => {
                  if (res.data.code == 0) {
                    this.$set(this.list.lives_will[index], 'lIsAppoint', 0);
                    this.$set(this.list.lives_will[index], 'lAppointNum', res.data.num);
                    this.$message.success('取消成功');
                  } else {
                    this.$message.error('取消预约失败')
                  }

                })


              }
            }]
          });

        }

      }

    },
    login() {
      loginService.login(this.$router).then((loginUser) => {
        this.ra_wxUser = loginUser;
        this.getData();
      });
    },

  },
  components: {
    iBanner,
    GetVipImg
  },
  async mounted() {
    this.ra_wxUser = await loginService.getLoginUser();
    
    this.getData();
    this.getUser();

  }
}
</script>
<style scoped lang="scss">
.item_title {
  font-size: 12px;
  margin-bottom: 10px;
  margin-top: 3px;
  display: flex;
  justify-content: space-between;

  .title_name {
    color: #666666;
    width: 110px;
    display: inline-block;
    display: -webkit-box;
    -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
    -webkit-line-clamp: 1; /*限制文本行数*/
    /*white-space: nowrap;      !*超出的空白区域不换行*!*/
    overflow: hidden; /*超出隐藏*/
    text-overflow: ellipsis; /*文本超出显示省略号*/
  }

  .title_time {
    color: #999999;
  }
}

.item_list {
  overflow: hidden;
  margin-bottom: 20px;
}

.con_bt {
  font-size: 14px;
  color: #999999;
  overflow: hidden;
  line-height: 16px;

  span:first-child {
    float: left;
  }

  s {
    font-size: 14px;
    color: #999999;
  }
}

.con_bt_r {
  font-size: 16px;
  float: right;
  color: #f00000;
}

.liveswill {
  border: 1px solid #e6e6e6;
  height: 280px !important;
  border-radius: 5px;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  width: 232px;
  cursor: pointer;
  padding: 0 10px;

  float: left;
  margin: 24px 24px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -ms-flex-pack: justify;
  -webkit-box-pack: justify;
  justify-content: flex-start;

  .con {
    margin-top: 6px;
  }

  .con_img_wrap{
    width: 210px;
    height: 118px;
  }

  .con_images {
    width: 210px !important;
    max-width: 100%;
    //height: 134px !important;
    max-height: 118px;
    border-radius: 5px !important;
    display: inline-block;
  }

  .con_title {
    font-size: 14px !important;
    color: #333 !important;
    line-height: 18px !important;
    height: 39px !important;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical; /*设置弹性盒模型子元素的排列方式*/
    -webkit-line-clamp: 2; /*限制文本行数*/
    /*white-space: nowrap;      !*超出的空白区域不换行*!*/
    overflow: hidden; /*超出隐藏*/
    text-overflow: ellipsis; /*文本超出显示省略号*/
  }

  .con_author {
    font-size: 12px !important;
    font-weight: 300 !important;
    color: #666666 !important;
    min-height: 14px !important;
    margin-top: 5px !important;
  }

  .last {
    padding: 0px !important;
    box-sizing: border-box !important;
    margin-top: 6px !important;
    height: 20px;
  }
}

.wrap {
  min-width: 1280px;
  width: 1280px;
  margin: 20px auto 0;
}

.banner {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  -webkit-box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.05),
  -3px 0 5px rgba(0, 0, 0, 0.05);
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.05), -3px 0 5px rgba(0, 0, 0, 0.05);
}

.container {
  min-width: 1280px;
  width: 1280px;
  margin-bottom: 0.98rem;
}

.filter-wrap {
  display: flex;
  align-items: center;
}

.filterItem {
  align-items: flex-start;
  width: 1280px;
  min-width: 1176px;
  border-bottom: 1px dashed #ebebeb;
  overflow: hidden;
  display: -ms-flexbox;
  display: flex;
  padding: 15px 0 6px;

  .title {
    font-size: 14px;
    float: left;
    line-height: 30px;
    color: #999;
    min-width: 70px;
    height: 30px;
    margin-right: 25px;
  }

  .filterRight {
    display: flex;
    line-height: 27px;
    flex-wrap: wrap; /*决定当排列不下时是否换行以及换行的方式*/
    span {
      font-size: 14px;
      cursor: pointer;
      padding: 2px 12px;
    }
  }

  .itemText {
    min-height: 20px;
    color: #333;
    margin-right: 8px;
    cursor: pointer;
    margin-bottom: 10px;
  }

  .itemActive {
    border-radius: 16px;
    background-color: #ffb441;
    color: #fff;
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/column/index.vue